<div
  class="container"
  *ngIf="currentItem$ | async as currentItem"
  prlwResponsive
>
  <div
    class="mobile-menu"
    *ngIf="xsmall$ | async; else commonButtons"
    #mobileMenu
  >
    <ng-container *ngIf="sectionButtonActive$ | async as sectionButtonActive">
      <prlw-section-button-ui
        *ngFor="let item of mobileItems"
        [label]="item.label"
        [idEvent]="item.section"
        [active]="item.section === sectionButtonActive"
        (idEvents)="handleChange($event)"
        [prlwScrollAnchorMenu]="item.section"
      ></prlw-section-button-ui>
    </ng-container>
  </div>
  <ng-template #commonButtons>
    <div>
      <prlw-section-button-ui
        *ngFor="let item of items"
        [label]="item.label"
        [idEvent]="item.section"
        [active]="item.section === currentItem"
        (idEvents)="handleChange($event)"
      ></prlw-section-button-ui>
      <div class="order-buy-button">
        <prlw-order-buy-button-ui
          [instrument]="instrument"
        ></prlw-order-buy-button-ui>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="xsmall$ | async; else commonMenu">
    <ng-container *ngIf="instrument.mode !== 'light'; else plug">
      <div class="section-mobile" prlwScrollAnchor="priceHistoryAnchor">
        <div class="ticker-price-label">
          <div class="ticker">{{ instrument.shipment.code }}</div>
          <prlw-text-tag-otp
            *ngIf="isOtp()"
            [instrumentCode]="instrument.instrumentCode"
            size="medium"
          ></prlw-text-tag-otp>
          <svg
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2" cy="2" r="2" fill="black" />
          </svg>
          <div>{{ instrument.quote.lastDealPrice | delimitNumber }} ₽</div>
        </div>
        <prlw-tw-price-history-chart
          [showLegend]="false"
          [chartData]="chartData$ | async"
          prlwResponsive
        ></prlw-tw-price-history-chart>
        <div class="legend-container" prlwResponsive>
          <prlw-graph-radio-group-ui
            appearance="grey-rect"
            [items]="graphRadioGroupPriceHistoryItems"
            [currentItem]="scale$ | async"
            (handleClick)="setScale($event)"
          ></prlw-graph-radio-group-ui>
        </div>
      </div>

      <div class="section-mobile" prlwScrollAnchor="marketDepthAnchor">
        <prlw-market-depth-ui
          [bid]="instrument.quote.bid"
          [ask]="instrument.quote.ask"
        ></prlw-market-depth-ui>
      </div>

      <div class="section-mobile" prlwScrollAnchor="deliveryTimeAnchor">
        <div class="legend-container" prlwResponsive>
          <prlw-basis-manufacturer-label-ui
            *ngIf="(xsmall$ | async) === false"
            [basisCode]="instrument.shipment.code"
            [manufacturer]="manufacturers"
          ></prlw-basis-manufacturer-label-ui>
          <prlw-graph-radio-group-ui
            [items]="graphRadioGroupDeliveryTimeItems"
            [currentItem]="sortMode$ | async"
            (handleClick)="toggleSortMode($event)"
          ></prlw-graph-radio-group-ui>
          <prlw-pin-basis-details-button-ui
            *ngIf="(xsmall$ | async) === false"
            [unpinned]="unpinned"
            [instrument]="instrument"
            (pinEvents)="pinEvent($event)"
          ></prlw-pin-basis-details-button-ui>
        </div>
        <prlw-delivery-time-graph></prlw-delivery-time-graph>
      </div>

      <div class="section-mobile last-deals" prlwScrollAnchor="lastDealsAnchor">
        <div class="last-deals-label">Последние сделки</div>

        <prlw-last-deals-table-header-row
          prlwSyncScroll
        ></prlw-last-deals-table-header-row>

        <prlw-last-deals-table
          [instrument]="instrument"
        ></prlw-last-deals-table>
      </div>
      <div class="order-buy-button" prlwResponsive>
        <prlw-order-buy-button-ui
          [instrument]="instrument"
        ></prlw-order-buy-button-ui>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #commonMenu>
    <div class="flex-grow section" prlwResponsive>
      <ng-container *ngIf="['info'].includes(currentItem)">
        <div class="container">
          <div class="flex-grow">
            <prlw-basis-details-section-info-ui
              *ngIf="currentItem === 'info'"
              [basisName]="instrument.shipment.name"
              [manufacturers]="manufacturers"
              [stationName]="instrument.shipment.name"
              [instrumentCode]="instrument.instrumentCode"
              [instrumentName]="instrument.instrumentName"
              [forecast]="forecast"
            ></prlw-basis-details-section-info-ui>
          </div>
          <prlw-pin-basis-details-button-ui
            [unpinned]="unpinned"
            [instrument]="instrument"
            (pinEvents)="pinEvent($event)"
          ></prlw-pin-basis-details-button-ui>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          ['priceHistory', 'deliveryTime', 'lastDeals', 'marketDepth'].includes(
            currentItem
          )
        "
      >
        <ng-container *ngIf="instrument.mode !== 'light'; else plug">
          <ng-container *ngIf="['priceHistory'].includes(currentItem)">
            <div>
              <div class="legend-container">
                <prlw-graph-radio-group-ui
                  class="common-menu-item"
                  appearance="grey-rect"
                  [items]="graphRadioGroupPriceHistoryItems"
                  [currentItem]="scale$ | async"
                  (handleClick)="setScale($event)"
                ></prlw-graph-radio-group-ui>
                <prlw-pin-basis-details-button-ui
                  [unpinned]="unpinned"
                  [instrument]="instrument"
                  (pinEvents)="pinEvent($event)"
                ></prlw-pin-basis-details-button-ui>
              </div>
              <prlw-tw-price-history-chart
                [ticker]="instrument.shipment.code + ' / ' + manufacturers"
                [chartData]="chartData$ | async"
              ></prlw-tw-price-history-chart>
            </div>
          </ng-container>

          <ng-container *ngIf="['deliveryTime'].includes(currentItem)">
            <div>
              <div class="legend-container">
                <prlw-basis-manufacturer-label-ui
                  [basisCode]="instrument.shipment.code"
                  [manufacturer]="manufacturers"
                ></prlw-basis-manufacturer-label-ui>
                <prlw-graph-radio-group-ui
                  [items]="graphRadioGroupDeliveryTimeItems"
                  [currentItem]="sortMode$ | async"
                  (handleClick)="toggleSortMode($event)"
                ></prlw-graph-radio-group-ui>
                <prlw-pin-basis-details-button-ui
                  [unpinned]="unpinned"
                  [instrument]="instrument"
                  (pinEvents)="pinEvent($event)"
                ></prlw-pin-basis-details-button-ui>
              </div>
            </div>
            <prlw-delivery-time-graph></prlw-delivery-time-graph>
          </ng-container>

          <ng-container *ngIf="['lastDeals'].includes(currentItem)">
            <div>
              <div class="legend-container">
                <prlw-basis-manufacturer-label-ui
                  [basisCode]="instrument.shipment.code"
                  [manufacturer]="manufacturers"
                ></prlw-basis-manufacturer-label-ui>
                <prlw-pin-basis-details-button-ui
                  [unpinned]="unpinned"
                  [instrument]="instrument"
                  (pinEvents)="pinEvent($event)"
                ></prlw-pin-basis-details-button-ui>
              </div>
            </div>
            <prlw-last-deals-table
              [instrument]="instrument"
              [isExpanded]="getIsExpanded()"
            ></prlw-last-deals-table>
          </ng-container>
          <ng-container *ngIf="['marketDepth'].includes(currentItem)">
            <prlw-market-depth-ui
              [bid]="instrument.quote.bid"
              [ask]="instrument.quote.ask"
            ></prlw-market-depth-ui>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>

<ng-template #plug>
  <prlw-light-mode-plug></prlw-light-mode-plug>
</ng-template>
